module.exports = __webpack_public_path__ + "img/mb-step-1.7ff02281.png";